/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { ISelectCategoryFacade } from "../../../../../data-access/src/lib/domain/facades-models/select-category-facade-interface";
import { Store } from "@ngrx/store";
import { selectManageMode } from "../tool-belt.selector";
import { LocalStorageService } from "../../../../../utils/src/lib/local-storage/local-storage.service";
import { GlobalConstants } from "../../constants/global-constants";

@Injectable({
    providedIn: 'root'
})
export class SelectCategoryFacade implements ISelectCategoryFacade{
    constructor(private store: Store, private localStorageService: LocalStorageService){}

    public selectManageMode() {
       return this.store.select(selectManageMode);
    }

    public getElectricalState() : any {
       return this.localStorageService.getStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
    }
}